import styled from 'styled-components';

export const LoadingSpinner = styled.div`
    &:before {
        content: '';
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        width: ${props => (props.width ? props.width : 30)}px;
        height: ${props => (props.width ? props.height : 30)}px;
        margin-top: -${props => (props.height ? props.height / 2 : 15)}px;
        margin-left: -${props => (props.width ? props.width / 2 : 15)}px;
        border-radius: 50%;
        border: ${props => (props.stroke ? props.stroke : 3)}px solid
            ${props => (props.color ? props.color : `rgba(255, 255, 255, 0.4)`)};
        border-top-color: #fff;
        animation: spinner 0.6s linear infinite;
    }

    @keyframes spinner {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.jsx